import React, { useState } from 'react'

import { Col, Container, Row } from 'react-bootstrap'
import SearchNot from '../../images/searchNot.png'
import LogList from './SensorLogListCard'
import EmptyReturn from '../EmptyReturn'

const SensorLogList = ({data}) => {
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
                   
            return <LogList key={index} item={item}/>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default SensorLogList
